import { EvalStore } from "components/Evaluation/Stores/EvalStore";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import P2Blurbs from "components/UI/P2Blurbs/P2Blurbs";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { AIExplanationNoHighlights } from "./AIExplanationNoHighlights";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material";

interface AIExplanationEddyContextProps {
    tagId: string;
}

const AIExplanationEddyContext = observer(
    (props: AIExplanationEddyContextProps) => {
        const store = useStore(EvalStore);
        const theme = useTheme();

        const isLoading = store.explanationLoadingStates[props.tagId];

        if (isLoading)
            return (
                <AcxLoadingIndicator
                    color="secondary"
                    alternate="PuffLoader"
                    size={32}
                    key={"spinner" + props.tagId}
                />
            );

        const data = store.eddyEffectP2Data;

        if (!data || data.length <= 0) return <AIExplanationNoHighlights />;
        return (
            <Grid item sx={{ padding: "10px" }}>
                {store.evalAudioTranscription && (
                    <P2Blurbs
                        transcription={
                            store.evalAudioTranscription.phrases ??
                            store.evalAudioTranscription.words ??
                            []
                        }
                        data={data}
                        sxBlurb={{ padding: theme.spacing(1, 1.5) }}
                        isPhrasesTranscript={
                            !!store.evalAudioTranscription.phrases
                        }
                        variant="eddy"
                    />
                )}
                {store.evalChat && (
                    <P2Blurbs
                        chat={store.evalChat}
                        data={data}
                        sxBlurb={{ padding: theme.spacing(1, 1.5) }}
                        variant="eddy"
                    />
                )}
            </Grid>
        );
    },
);

export default AIExplanationEddyContext;
